import snakecaseKeys from 'snakecase-keys'
import axiosIns from '@/plugins/axios'

export default {
  getPermissionGroups(params = {}) {
    return axiosIns.get('/v2/security/permission_groups', {
      params: snakecaseKeys(params),
    })
  },

  getPermissions(params = {}) {
    return axiosIns.get('/v2/security/permissions', {
      params: snakecaseKeys(params),
    })
  },

  getCustomUsers() {
    return axiosIns.get('/v2/security/custom_users')
  },

  createPermissionGroup(data) {
    return axiosIns.post('/v2/security/permission_groups', snakecaseKeys(data, { deep: true }))
  },

  deletePermissionGroup(groupId) {
    return axiosIns.delete(`/v2/security/permission_groups/${groupId}`)
  },

  updatePermissionGroup(groupId, data) {
    return axiosIns.patch(`/v2/security/permission_groups/${groupId}`, snakecaseKeys(data, { deep: true }))
  },

  assignPermissionGroups(userId, permissionGroupIds) {
    return axiosIns.post('/v2/security/permission_groups/assign', snakecaseKeys({
      userId,
      permissionGroupIds,
    }))
  },
}
